import { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal, Vertical } from 'atoms/layout/flex';
import { HeadlineXS } from 'atoms/typography';
import { tabletAndAbove } from 'style/mediaQuery';

import { ActionType, Cta, StatusType } from '../Friend/Cta';

const Root = styled(Vertical).attrs({ gap: 0 })`
  position: relative;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;
const AvatarWrapper = styled(Horizontal)`
  position: relative;
  width: 100%;
  padding-top: var(--double-unit);
`;
const ContentWrapper = styled.div`
  position: relative;
  object-fit: cover;
  border-radius: 50%;
`;
const Ellipsis = styled.div`
  max-width: 100%;
  &,
  > * {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const CtaWrapper = styled(Vertical)`
  flex: 1;
  margin-top: var(--unit);
  justify-content: flex-end;

  @media ${tabletAndAbove} {
    flex-direction: row-reverse;
    align-items: flex-end;
  }
`;
const StyledVertical = styled(Vertical)`
  width: 100%;
`;

export type Props = {
  content: ReactNode;
  name: ReactNode;
  extra?: ReactNode;
  status?: StatusType;
  disabled?: boolean;
  onClick?: (action: ActionType) => void;
  hideAccept?: boolean;
  cta?: ReactNode;
};
export const FriendMatchupItem = ({
  content,
  name,
  extra,
  status,
  disabled,
  onClick,
  hideAccept,
  cta,
}: Props) => {
  return (
    <Root>
      <StyledVertical center>
        <AvatarWrapper center>
          <ContentWrapper>{content}</ContentWrapper>
        </AvatarWrapper>
        <Ellipsis>
          <HeadlineXS as="span">{name}</HeadlineXS>
        </Ellipsis>
      </StyledVertical>
      {extra}
      <CtaWrapper>
        {status &&
          (cta !== undefined ? (
            cta
          ) : (
            <Cta
              status={status}
              disabled={disabled}
              onClick={onClick}
              hideAccept={hideAccept}
            />
          ))}
      </CtaWrapper>
    </Root>
  );
};
